module.exports = __webpack_public_path__ + "img/img_wujilu.16d673c4.png";